module.exports = __webpack_public_path__ + "img/placeholder_hiw_build.png";